var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// lib/NotifiService.ts
import { v4 as uuid } from "uuid";

// package.json
var version = "3.1.0";

// lib/gql/subscriptions/stateChanged.gql.ts
import { gql } from "graphql-request";
var stateChangedSubscriptionQuery = `
  subscription stateChanged {
    stateChanged {
      ... on TargetStateChangedEvent {
        __typename
        targetId
        targetType
        timestamp
      }
      ... on NotificationHistoryStateChangedEvent {
        __typename
        timestamp
      }
    }
  }
`;
gql`
  ${stateChangedSubscriptionQuery}
`;

// lib/gql/fragments/ActiveAlertFragment.gql.ts
import { gql as gql2 } from "graphql-request";
var ActiveAlertFragment = gql2`
  fragment ActiveAlertFragment on ActiveAlert {
    __typename
    id
    filterOptionsJson
    fusionEventId
    subscriptionValue
    user {
      __typename
      id
      connectedWallets {
        address
        walletBlockchain
      }
    }
  }
`;

// lib/gql/subscriptions/tenantActiveAlertChanged.gql.ts
import { gql as gql3 } from "graphql-request";
var tenantActiveAlertChangedSubscriptionQuery = `
  subscription tenantActiveAlertChanged {
    tenantActiveAlertChanged {
      __typename
      ... on ActiveAlertCreatedEvent {
        __typename
        activeAlert {
          ...ActiveAlertFragment
        }
      }
      ... on ActiveAlertDeletedEvent {
        alertId
        timestamp
        userId
      }
    }
  }
  ${ActiveAlertFragment}
`;
gql3`
  ${tenantActiveAlertChangedSubscriptionQuery}
`;

// ../../node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// ../../node_modules/graphql-tag/lib/index.js
import { parse } from "graphql";
var docCache = /* @__PURE__ */ new Map();
var fragmentSourceMap = /* @__PURE__ */ new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
  return string.replace(/[\s,]+/g, " ").trim();
}
function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
  var seenKeys = /* @__PURE__ */ new Set();
  var definitions = [];
  ast.definitions.forEach(function(fragmentDefinition) {
    if (fragmentDefinition.kind === "FragmentDefinition") {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
      var sourceKeySet = fragmentSourceMap.get(fragmentName);
      if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }
      } else if (!sourceKeySet) {
        fragmentSourceMap.set(fragmentName, sourceKeySet = /* @__PURE__ */ new Set());
      }
      sourceKeySet.add(sourceKey);
      if (!seenKeys.has(sourceKey)) {
        seenKeys.add(sourceKey);
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  });
  return __assign(__assign({}, ast), { definitions });
}
function stripLoc(doc) {
  var workSet = new Set(doc.definitions);
  workSet.forEach(function(node) {
    if (node.loc)
      delete node.loc;
    Object.keys(node).forEach(function(key) {
      var value = node[key];
      if (value && typeof value === "object") {
        workSet.add(value);
      }
    });
  });
  var loc = doc.loc;
  if (loc) {
    delete loc.startToken;
    delete loc.endToken;
  }
  return doc;
}
function parseDocument(source) {
  var cacheKey = normalize(source);
  if (!docCache.has(cacheKey)) {
    var parsed = parse(source, {
      experimentalFragmentVariables,
      allowLegacyFragmentVariables: experimentalFragmentVariables
    });
    if (!parsed || parsed.kind !== "Document") {
      throw new Error("Not a valid GraphQL document.");
    }
    docCache.set(cacheKey, stripLoc(processFragments(parsed)));
  }
  return docCache.get(cacheKey);
}
function gql4(literals) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (typeof literals === "string") {
    literals = [literals];
  }
  var result = literals[0];
  args.forEach(function(arg, i) {
    if (arg && arg.kind === "Document") {
      result += arg.loc.source.body;
    } else {
      result += arg;
    }
    result += literals[i + 1];
  });
  return parseDocument(result);
}
function resetCaches() {
  docCache.clear();
  fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
  printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}
var extras = {
  gql: gql4,
  resetCaches,
  disableFragmentWarnings,
  enableExperimentalFragmentVariables,
  disableExperimentalFragmentVariables
};
(function(gql_1) {
  gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql4 || (gql4 = {}));
gql4["default"] = gql4;
var lib_default = gql4;

// lib/gql/generated.ts
var ActiveAlertFragmentFragmentDoc = lib_default`
    fragment ActiveAlertFragment on ActiveAlert {
  __typename
  id
  filterOptionsJson
  fusionEventId
  subscriptionValue
  user {
    __typename
    id
    connectedWallets {
      address
      walletBlockchain
    }
  }
}
    `;
var FilterFragmentFragmentDoc = lib_default`
    fragment FilterFragment on Filter {
  id
  name
  filterType
}
    `;
var SourceFragmentFragmentDoc = lib_default`
    fragment SourceFragment on Source {
  id
  name
  type
  blockchainAddress
  fusionEventTypeId
  applicableFilters {
    ...FilterFragment
  }
}
    ${FilterFragmentFragmentDoc}`;
var SourceGroupFragmentFragmentDoc = lib_default`
    fragment SourceGroupFragment on SourceGroup {
  id
  name
  sources {
    ...SourceFragment
  }
}
    ${SourceFragmentFragmentDoc}`;
var EmailTargetFragmentFragmentDoc = lib_default`
    fragment EmailTargetFragment on EmailTarget {
  emailAddress
  id
  isConfirmed
  name
}
    `;
var SmsTargetFragmentFragmentDoc = lib_default`
    fragment SmsTargetFragment on SmsTarget {
  id
  isConfirmed
  name
  phoneNumber
}
    `;
var TelegramTargetFragmentFragmentDoc = lib_default`
    fragment TelegramTargetFragment on TelegramTarget {
  id
  isConfirmed
  name
  telegramId
  confirmationUrl
}
    `;
var WebhookTargetFragmentFragmentDoc = lib_default`
    fragment WebhookTargetFragment on WebhookTarget {
  id
  url
  status
  format
  headers {
    key
    value
  }
  name
}
    `;
var DiscordTargetFragmentFragmentDoc = lib_default`
    fragment DiscordTargetFragment on DiscordTarget {
  id
  discordAccountId
  discriminator
  isConfirmed
  username
  name
  userStatus
  verificationLink
  discordServerInviteLink
}
    `;
var SlackChannelTargetFragmentFragmentDoc = lib_default`
    fragment SlackChannelTargetFragment on SlackChannelTarget {
  id
  name
  slackChannelName
  slackWorkspaceName
  verificationLink
  webhookVerificationLink
  verificationStatus
}
    `;
var Web3TargetFragmentFragmentDoc = lib_default`
    fragment Web3TargetFragment on Web3Target {
  id
  name
  accountId
  walletBlockchain
  targetProtocol
  isConfirmed
  senderAddress
}
    `;
var TargetGroupFragmentFragmentDoc = lib_default`
    fragment TargetGroupFragment on TargetGroup {
  id
  name
  emailTargets {
    ...EmailTargetFragment
  }
  smsTargets {
    ...SmsTargetFragment
  }
  telegramTargets {
    ...TelegramTargetFragment
  }
  webhookTargets {
    ...WebhookTargetFragment
  }
  discordTargets {
    ...DiscordTargetFragment
  }
  slackChannelTargets {
    ...SlackChannelTargetFragment
  }
  web3Targets {
    ...Web3TargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}
${SmsTargetFragmentFragmentDoc}
${TelegramTargetFragmentFragmentDoc}
${WebhookTargetFragmentFragmentDoc}
${DiscordTargetFragmentFragmentDoc}
${SlackChannelTargetFragmentFragmentDoc}
${Web3TargetFragmentFragmentDoc}`;
var AlertFragmentFragmentDoc = lib_default`
    fragment AlertFragment on Alert {
  id
  groupName
  name
  filterOptions
  filter {
    ...FilterFragment
  }
  sourceGroup {
    ...SourceGroupFragment
  }
  targetGroup {
    ...TargetGroupFragment
  }
}
    ${FilterFragmentFragmentDoc}
${SourceGroupFragmentFragmentDoc}
${TargetGroupFragmentFragmentDoc}`;
var ConnectedWalletFragmentFragmentDoc = lib_default`
    fragment ConnectedWalletFragment on ConnectedWallet {
  address
  walletBlockchain
}
    `;
var FusionNotificationHistoryEntryFragmentFragmentDoc = lib_default`
    fragment FusionNotificationHistoryEntryFragment on FusionNotificationHistoryEntry {
  __typename
  id
  createdDate
  read
  fusionEventVariables
  detail {
    __typename
    ... on AccountBalanceChangedEventDetails {
      walletBlockchain
      direction
      newValue
      previousValue
      tokenSymbol
      isWhaleWatch
    }
    ... on BroadcastMessageEventDetails {
      messageType: type
      subject
      message
      messageHtml
    }
    ... on DirectTenantMessageEventDetails {
      tenantName
      targetTemplatesJson
      templateVariablesJson
    }
    ... on NftCollectionsReportEventDetails {
      type
      providerName
      sourceLink
      collections {
        collectionId
        name
        imgUrl
        volume1Day
        volume1DayChange
      }
    }
    ... on DAOProposalChangedEventDetails {
      tenantName
      proposalTitle: title
      description
      state
      daoUrl
      proposalUrl
    }
    ... on NftAuctionChangedEventDetails {
      auctionTitle: title
      auctionUrl
      walletBlockchain
      highBidAmount
      highBidSymbol
      imageUrl
    }
    ... on WalletsActivityReportEventDetails {
      providerName
      sourceLink
      walletActivityType: type
      wallets {
        address
        volume1Day
        maxPurchase1Day
        maxPurchaseName
        maxPurchaseImgUrl
        maxPurchaseTokenAddress
      }
    }
    ... on HealthValueOverThresholdEventDetails {
      name
      value
      threshold
      url
    }
    ... on GenericEventDetails {
      sourceName
      notificationTypeName
      genericMessage: message
      genericMessageHtml: messageHtml
      eventDetailsJson
      action {
        name
        url
      }
      icon
      customIconUrl
    }
  }
}
    `;
var NotificationHistoryEntryFragmentFragmentDoc = lib_default`
    fragment NotificationHistoryEntryFragment on NotificationHistoryEntry {
  __typename
  id
  createdDate
  eventId
  read
  sourceAddress
  category
  transactionSignature
  targets {
    type
    name
  }
  detail {
    __typename
    ... on AccountBalanceChangedEventDetails {
      walletBlockchain
      direction
      newValue
      previousValue
      tokenSymbol
      isWhaleWatch
    }
    ... on BroadcastMessageEventDetails {
      messageType: type
      subject
      message
      messageHtml
    }
    ... on DirectTenantMessageEventDetails {
      tenantName
      targetTemplatesJson
      templateVariablesJson
    }
    ... on NftCollectionsReportEventDetails {
      type
      providerName
      sourceLink
      collections {
        collectionId
        name
        imgUrl
        volume1Day
        volume1DayChange
      }
    }
    ... on DAOProposalChangedEventDetails {
      tenantName
      proposalTitle: title
      description
      state
      daoUrl
      proposalUrl
    }
    ... on NftAuctionChangedEventDetails {
      auctionTitle: title
      auctionUrl
      walletBlockchain
      highBidAmount
      highBidSymbol
      imageUrl
    }
    ... on WalletsActivityReportEventDetails {
      providerName
      sourceLink
      walletActivityType: type
      wallets {
        address
        volume1Day
        maxPurchase1Day
        maxPurchaseName
        maxPurchaseImgUrl
        maxPurchaseTokenAddress
      }
    }
    ... on HealthValueOverThresholdEventDetails {
      name
      value
      threshold
      url
    }
    ... on GenericEventDetails {
      sourceName
      notificationTypeName
      genericMessage: message
      genericMessageHtml: messageHtml
      eventDetailsJson
      action {
        name
        url
      }
      icon
    }
  }
}
    `;
var PageInfoFragmentFragmentDoc = lib_default`
    fragment PageInfoFragment on PageInfo {
  hasNextPage
  endCursor
}
    `;
var CreateSlackChannelTargetResponseFragmentFragmentDoc = lib_default`
    fragment CreateSlackChannelTargetResponseFragment on CreateSlackChannelTargetResponse {
  slackChannelTarget {
    id
    name
    slackChannelName
    slackWorkspaceName
    verificationLink
    webhookVerificationLink
    verificationStatus
  }
}
    `;
var GetSlackChannelTargetsResponseFragmentFragmentDoc = lib_default`
    fragment GetSlackChannelTargetsResponseFragment on SlackChannelTargetsConnection {
  edges {
    cursor
  }
  pageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
  nodes {
    id
    name
    slackChannelName
    slackWorkspaceName
    verificationLink
    webhookVerificationLink
    verificationStatus
  }
}
    `;
var TenantConfigFragmentFragmentDoc = lib_default`
    fragment TenantConfigFragment on TenantConfig {
  id
  type
  dataJson
  fusionEvents {
    id
    metadata
    name
  }
}
    `;
var TenantUserAlertFragmentFragmentDoc = lib_default`
    fragment TenantUserAlertFragment on TenantUserAlert {
  id
  name
  groupName
  filterOptions
  filter {
    ...FilterFragment
  }
  sourceGroup {
    ...SourceGroupFragment
  }
  targetGroup {
    hasVerifiedFcm
    hasVerifiedSms
    hasVerifiedWeb3
    hasVerifiedEmails
    hasVerifiedWebhook
    hasVerifiedDiscord
    hasVerifiedTelegram
  }
}
    ${FilterFragmentFragmentDoc}
${SourceGroupFragmentFragmentDoc}`;
var TenantConnectedWalletFragmentFragmentDoc = lib_default`
    fragment TenantConnectedWalletFragment on TenantConnectedWallet {
  address
  walletBlockchain
}
    `;
var TenantUserFragmentFragmentDoc = lib_default`
    fragment TenantUserFragment on TenantUser {
  id
  alerts {
    ...TenantUserAlertFragment
  }
  connectedWallets {
    ...TenantConnectedWalletFragment
  }
}
    ${TenantUserAlertFragmentFragmentDoc}
${TenantConnectedWalletFragmentFragmentDoc}`;
var AuthorizationFragmentFragmentDoc = lib_default`
    fragment AuthorizationFragment on Authorization {
  token
  expiry
}
    `;
var UserFragmentFragmentDoc = lib_default`
    fragment UserFragment on User {
  email
  emailConfirmed
  authorization {
    ...AuthorizationFragment
  }
  roles
}
    ${AuthorizationFragmentFragmentDoc}`;
var UserTopicFragmentFragmentDoc = lib_default`
    fragment UserTopicFragment on UserTopic {
  name
  topicName
  targetCollections
  targetTemplate
}
    `;
var GetWeb3TargetResponseFragmentFragmentDoc = lib_default`
    fragment GetWeb3TargetResponseFragment on Web3TargetsConnection {
  edges {
    cursor
  }
  pageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
  nodes {
    id
    name
    accountId
    walletBlockchain
    targetProtocol
    isConfirmed
    senderAddress
  }
}
    `;
var VerifyXmtpTargetResponseFragmentFragmentDoc = lib_default`
    fragment VerifyXmtpTargetResponseFragment on VerifyXmtpTargetResponse {
  web3Target {
    id
    name
    accountId
    walletBlockchain
    targetProtocol
    isConfirmed
    senderAddress
  }
}
    `;
var VerifyCbwTargetResponseFragmentFragmentDoc = lib_default`
    fragment VerifyCbwTargetResponseFragment on VerifyCbwTargetResponse {
  web3Target {
    id
    name
    accountId
    walletBlockchain
    targetProtocol
    isConfirmed
    senderAddress
  }
}
    `;
var VerifyXmtpTargetViaXip42ResponseFragmentFragmentDoc = lib_default`
    fragment VerifyXmtpTargetViaXip42ResponseFragment on VerifyXmtpTargetViaXip42Response {
  web3Target {
    id
    name
    accountId
    walletBlockchain
    targetProtocol
    isConfirmed
    senderAddress
  }
}
    `;
var WebPushTargetFragmentFragmentDoc = lib_default`
    fragment WebPushTargetFragment on WebPushTarget {
  id
  createdDate
  name
}
    `;
var AddSourceToSourceGroupDocument = lib_default`
    mutation addSourceToSourceGroup($input: AddSourceToSourceGroupInput!) {
  addSourceToSourceGroup(addSourceToSourceGroupInput: $input) {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var BeginLogInByTransactionDocument = lib_default`
    mutation beginLogInByTransaction($walletAddress: String!, $walletBlockchain: WalletBlockchain!, $dappAddress: String!) {
  beginLogInByTransaction(
    beginLogInByTransactionInput: {walletAddress: $walletAddress, walletBlockchain: $walletBlockchain, dappAddress: $dappAddress}
  ) {
    nonce
  }
}
    `;
var BeginLogInWithWeb3Document = lib_default`
    mutation beginLogInWithWeb3($authAddress: String!, $blockchainType: WalletBlockchain!, $dappAddress: String!, $authType: Web3AuthType!, $walletPubkey: String) {
  beginLogInWithWeb3(
    beginLogInWithWeb3Input: {authAddress: $authAddress, blockchainType: $blockchainType, dappAddress: $dappAddress, authType: $authType, walletPubkey: $walletPubkey}
  ) {
    beginLogInWithWeb3Response {
      nonce
    }
  }
}
    `;
var BroadcastMessageDocument = lib_default`
    mutation broadcastMessage($idempotencyKey: String, $topicName: String!, $targetTemplates: [KeyValuePairOfTargetTypeAndStringInput!], $variables: [KeyValuePairOfStringAndStringInput!], $timestamp: Long!, $walletBlockchain: WalletBlockchain!, $signature: String!) {
  broadcastMessage(
    broadcastMessageInput: {idempotencyKey: $idempotencyKey, sourceAddress: $topicName, targetTemplates: $targetTemplates, variables: $variables, timestamp: $timestamp, walletBlockchain: $walletBlockchain}
    signature: $signature
  ) {
    id
  }
}
    `;
var CompleteLogInByTransactionDocument = lib_default`
    mutation completeLogInByTransaction($walletAddress: String!, $walletBlockchain: WalletBlockchain!, $dappAddress: String!, $randomUuid: String!, $transactionSignature: String!) {
  completeLogInByTransaction(
    completeLogInByTransactionInput: {walletAddress: $walletAddress, walletBlockchain: $walletBlockchain, dappAddress: $dappAddress, randomUuid: $randomUuid, transactionSignature: $transactionSignature}
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
var CompleteLogInWithWeb3Document = lib_default`
    mutation completeLogInWithWeb3($nonce: String!, $signature: String!, $signedMessage: String!, $signingAddress: String!, $signingPubkey: String!) {
  completeLogInWithWeb3(
    completeLogInWithWeb3Input: {nonce: $nonce, signature: $signature, signedMessage: $signedMessage, signingAddress: $signingAddress, signingPubkey: $signingPubkey}
  ) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
var ConnectWalletDocument = lib_default`
    mutation connectWallet($walletPublicKey: String!, $timestamp: Long!, $signature: String!, $walletBlockchain: WalletBlockchain!, $accountId: String, $connectWalletConflictResolutionTechnique: ConnectWalletConflictResolutionTechnique) {
  connectWallet(
    connectWalletInput: {walletPublicKey: $walletPublicKey, timestamp: $timestamp, walletBlockchain: $walletBlockchain, accountId: $accountId, connectWalletConflictResolutionTechnique: $connectWalletConflictResolutionTechnique}
    signature: $signature
  ) {
    ...ConnectedWalletFragment
  }
}
    ${ConnectedWalletFragmentFragmentDoc}`;
var CreateAlertDocument = lib_default`
    mutation createAlert($name: String!, $sourceGroupId: String!, $filterId: String!, $targetGroupId: String!, $filterOptions: String!, $groupName: String!) {
  createAlert(
    alertInput: {name: $name, sourceGroupId: $sourceGroupId, filterId: $filterId, targetGroupId: $targetGroupId, filterOptions: $filterOptions, groupName: $groupName}
  ) {
    ...AlertFragment
  }
}
    ${AlertFragmentFragmentDoc}`;
var CreateDirectPushAlertDocument = lib_default`
    mutation createDirectPushAlert($input: CreateDirectPushAlertInput!) {
  createDirectPushAlert(createDirectPushAlertInput: $input) {
    ...AlertFragment
  }
}
    ${AlertFragmentFragmentDoc}`;
var CreateDiscordTargetDocument = lib_default`
    mutation createDiscordTarget($name: String!, $value: String!) {
  createDiscordTarget(createTargetInput: {name: $name, value: $value}) {
    ...DiscordTargetFragment
  }
}
    ${DiscordTargetFragmentFragmentDoc}`;
var CreateEmailTargetDocument = lib_default`
    mutation createEmailTarget($name: String!, $value: String!) {
  createEmailTarget(createTargetInput: {name: $name, value: $value}) {
    ...EmailTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}`;
var CreateFusionAlertsDocument = lib_default`
    mutation createFusionAlerts($input: CreateFusionAlertsInput!) {
  createFusionAlerts(input: $input) {
    alerts {
      groupName
      id
      name
      filterOptions
    }
    errors {
      ... on ArgumentError {
        __typename
        message
        paramName
      }
      ... on ArgumentNullError {
        __typename
        message
        paramName
      }
      ... on ArgumentOutOfRangeError {
        __typename
        message
        paramName
      }
    }
  }
}
    `;
var CreateSlackChannelTargetDocument = lib_default`
    mutation createSlackChannelTarget($name: String!, $value: String!) {
  createSlackChannelTarget(input: {name: $name, value: $value}) {
    ...CreateSlackChannelTargetResponseFragment
  }
}
    ${CreateSlackChannelTargetResponseFragmentFragmentDoc}`;
var CreateSmsTargetDocument = lib_default`
    mutation createSmsTarget($name: String!, $value: String!) {
  createSmsTarget(createTargetInput: {name: $name, value: $value}) {
    ...SmsTargetFragment
  }
}
    ${SmsTargetFragmentFragmentDoc}`;
var CreateSourceDocument = lib_default`
    mutation createSource($name: String, $blockchainAddress: String!, $type: SourceType!, $fusionEventTypeId: String) {
  createSource(
    createSourceInput: {name: $name, blockchainAddress: $blockchainAddress, type: $type, fusionEventTypeId: $fusionEventTypeId}
  ) {
    ...SourceFragment
  }
}
    ${SourceFragmentFragmentDoc}`;
var CreateSourceGroupDocument = lib_default`
    mutation createSourceGroup($name: String!, $sourceIds: [String!]!) {
  createSourceGroup(sourceGroupInput: {name: $name, sourceIds: $sourceIds}) {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var CreateTargetGroupDocument = lib_default`
    mutation createTargetGroup($name: String!, $emailTargetIds: [String!]!, $smsTargetIds: [String!]!, $telegramTargetIds: [String!]!, $webhookTargetIds: [String!]!, $discordTargetIds: [String!]!, $slackChannelTargetIds: [String!]!, $web3TargetIds: [String!]!) {
  createTargetGroup(
    targetGroupInput: {name: $name, emailTargetIds: $emailTargetIds, smsTargetIds: $smsTargetIds, telegramTargetIds: $telegramTargetIds, webhookTargetIds: $webhookTargetIds, discordTargetIds: $discordTargetIds, slackChannelTargetIds: $slackChannelTargetIds, web3TargetIds: $web3TargetIds}
  ) {
    ...TargetGroupFragment
  }
}
    ${TargetGroupFragmentFragmentDoc}`;
var CreateTelegramTargetDocument = lib_default`
    mutation createTelegramTarget($name: String!, $value: String!) {
  createTelegramTarget(createTargetInput: {name: $name, value: $value}) {
    ...TelegramTargetFragment
  }
}
    ${TelegramTargetFragmentFragmentDoc}`;
var CreateTenantUserDocument = lib_default`
    mutation createTenantUser($input: CreateTenantUserInput!) {
  createTenantUser(createTenantUserInput: $input) {
    ...TenantUserFragment
  }
}
    ${TenantUserFragmentFragmentDoc}`;
var CreateWeb3TargetDocument = lib_default`
    mutation createWeb3Target($name: String!, $accountId: String!, $walletBlockchain: WalletBlockchain!, $web3TargetProtocol: Web3TargetProtocol!) {
  createWeb3Target(
    createWeb3TargetInput: {name: $name, accountId: $accountId, walletBlockchain: $walletBlockchain, protocol: $web3TargetProtocol}
  ) {
    ...Web3TargetFragment
  }
}
    ${Web3TargetFragmentFragmentDoc}`;
var CreateWebPushTargetDocument = lib_default`
    mutation createWebPushTarget($vapidPublicKey: String!, $endpoint: String!, $auth: String!, $p256dh: String!) {
  createWebPushTarget(
    input: {vapidPublicKey: $vapidPublicKey, endpoint: $endpoint, auth: $auth, p256dh: $p256dh}
  ) {
    webPushTarget {
      ...WebPushTargetFragment
    }
    errors {
      ... on TargetLimitExceededError {
        message
      }
      ... on UnexpectedError {
        message
      }
    }
  }
}
    ${WebPushTargetFragmentFragmentDoc}`;
var CreateWebhookTargetDocument = lib_default`
    mutation createWebhookTarget($name: String!, $url: String!, $format: WebhookPayloadFormat!, $headers: [KeyValuePairOfStringAndStringInput!]!) {
  createWebhookTarget(
    createTargetInput: {name: $name, url: $url, format: $format, headers: $headers}
  ) {
    ...WebhookTargetFragment
  }
}
    ${WebhookTargetFragmentFragmentDoc}`;
var DeleteAlertDocument = lib_default`
    mutation deleteAlert($id: String!) {
  deleteAlert(alertId: $id) {
    id
  }
}
    `;
var DeleteDirectPushAlertDocument = lib_default`
    mutation deleteDirectPushAlert($input: DeleteDirectPushAlertInput!) {
  deleteDirectPushAlert(deleteDirectPushAlertInput: $input) {
    id
  }
}
    `;
var DeleteSourceGroupDocument = lib_default`
    mutation deleteSourceGroup($id: String!) {
  deleteSourceGroup(sourceGroupInput: {id: $id}) {
    id
  }
}
    `;
var DeleteTargetGroupDocument = lib_default`
    mutation deleteTargetGroup($id: String!) {
  deleteTargetGroup(targetGroupInput: {id: $id}) {
    id
  }
}
    `;
var DeleteUserAlertDocument = lib_default`
    mutation deleteUserAlert($alertId: String!) {
  deleteUserAlert(alertId: $alertId) {
    id
  }
}
    `;
var DeleteWebPushTargetDocument = lib_default`
    mutation deleteWebPushTarget($id: String!) {
  deleteWebPushTarget(input: {id: $id}) {
    success
    errors {
      ... on TargetDoesNotExistError {
        message
      }
      ... on UnexpectedError {
        message
      }
    }
  }
}
    `;
var DeleteWebhookTargetDocument = lib_default`
    mutation deleteWebhookTarget($id: String!) {
  deleteWebhookTarget(deleteTargetInput: {id: $id}) {
    id
  }
}
    `;
var LogInByOidcDocument = lib_default`
    mutation logInByOidc($dappId: String!, $oidcProvider: OidcProvider!, $idToken: String!) {
  logInByOidc(
    input: {dappId: $dappId, oidcProvider: $oidcProvider, idToken: $idToken}
  ) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;
var LogInFromDappDocument = lib_default`
    mutation logInFromDapp($walletBlockchain: WalletBlockchain!, $walletPublicKey: String!, $dappAddress: String!, $timestamp: Long!, $signature: String!, $accountId: String) {
  logInFromDapp(
    dappLogInInput: {walletBlockchain: $walletBlockchain, walletPublicKey: $walletPublicKey, dappAddress: $dappAddress, timestamp: $timestamp, accountId: $accountId}
    signature: $signature
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
var LogInFromServiceDocument = lib_default`
    mutation logInFromService($input: ServiceLogInInput!) {
  logInFromService(serviceLogInInput: $input) {
    ...AuthorizationFragment
  }
}
    ${AuthorizationFragmentFragmentDoc}`;
var MarkFusionNotificationHistoryAsReadDocument = lib_default`
    mutation markFusionNotificationHistoryAsRead($ids: [String!]!, $beforeId: String, $readState: NotificationHistoryReadState) {
  markFusionNotificationHistoryAsRead(
    input: {ids: $ids, beforeId: $beforeId, readState: $readState}
  )
}
    `;
var PublishFusionMessageDocument = lib_default`
    mutation publishFusionMessage($eventTypeId: String!, $variablesJson: String!, $specificWallets: [KeyValuePairOfStringAndWalletBlockchainInput!]) {
  publishFusionMessage(
    publishFusionMessageInput: {eventTypeId: $eventTypeId, variablesJson: $variablesJson, specificWallets: $specificWallets}
  ) {
    eventUuid
  }
}
    `;
var RefreshAuthorizationDocument = lib_default`
    mutation refreshAuthorization {
  refreshAuthorization {
    ...AuthorizationFragment
  }
}
    ${AuthorizationFragmentFragmentDoc}`;
var RemoveSourceFromSourceGroupDocument = lib_default`
    mutation removeSourceFromSourceGroup($input: RemoveSourceFromSourceGroupInput!) {
  removeSourceFromSourceGroup(removeSourceFromSourceGroupInput: $input) {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var SendEmailTargetVerificationRequestDocument = lib_default`
    mutation sendEmailTargetVerificationRequest($targetId: String!) {
  sendEmailTargetVerificationRequest(
    sendTargetConfirmationRequestInput: {targetId: $targetId}
  ) {
    ...EmailTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}`;
var SendMessageDocument = lib_default`
    mutation sendMessage($input: SendMessageInput!) {
  sendMessage(sendMessageInput: $input)
}
    `;
var UpdateSourceGroupDocument = lib_default`
    mutation updateSourceGroup($id: String!, $name: String!, $sourceIds: [String!]!) {
  updateSourceGroup: createSourceGroup(
    sourceGroupInput: {id: $id, name: $name, sourceIds: $sourceIds}
  ) {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var UpdateTargetGroupDocument = lib_default`
    mutation updateTargetGroup($id: String!, $name: String!, $emailTargetIds: [String!]!, $smsTargetIds: [String!]!, $telegramTargetIds: [String!]!, $webhookTargetIds: [String!]!, $discordTargetIds: [String!]!, $slackChannelTargetIds: [String!]!, $web3TargetIds: [String!]!) {
  updateTargetGroup: createTargetGroup(
    targetGroupInput: {id: $id, name: $name, emailTargetIds: $emailTargetIds, smsTargetIds: $smsTargetIds, telegramTargetIds: $telegramTargetIds, webhookTargetIds: $webhookTargetIds, discordTargetIds: $discordTargetIds, slackChannelTargetIds: $slackChannelTargetIds, web3TargetIds: $web3TargetIds}
  ) {
    ...TargetGroupFragment
  }
}
    ${TargetGroupFragmentFragmentDoc}`;
var UpdateUserSettingsDocument = lib_default`
    mutation updateUserSettings($input: UserSettingsInput!) {
  updateUserSettings(userSettings: $input) {
    detailedAlertHistoryEnabled
    userHasChatEnabled
    ftuStage
  }
}
    `;
var UpdateWebPushTargetDocument = lib_default`
    mutation updateWebPushTarget($id: String!, $endpoint: String!, $auth: String!, $p256dh: String!) {
  updateWebPushTarget(
    input: {id: $id, endpoint: $endpoint, auth: $auth, p256dh: $p256dh}
  ) {
    webPushTarget {
      ...WebPushTargetFragment
    }
    errors {
      ... on TargetDoesNotExistError {
        message
      }
      ... on UnexpectedError {
        message
      }
    }
  }
}
    ${WebPushTargetFragmentFragmentDoc}`;
var VerifyCbwTargetDocument = lib_default`
    mutation verifyCbwTarget($input: VerifyCbwTargetInput!) {
  verifyCbwTarget(input: $input) {
    ...VerifyCbwTargetResponseFragment
  }
}
    ${VerifyCbwTargetResponseFragmentFragmentDoc}`;
var VerifyXmtpTargetDocument = lib_default`
    mutation verifyXmtpTarget($input: VerifyXmtpTargetInput!) {
  verifyXmtpTarget(input: $input) {
    ...VerifyXmtpTargetResponseFragment
  }
}
    ${VerifyXmtpTargetResponseFragmentFragmentDoc}`;
var VerifyXmtpTargetViaXip42Document = lib_default`
    mutation verifyXmtpTargetViaXip42($input: VerifyXmtpTargetViaXip42Input!) {
  verifyXmtpTargetViaXip42(input: $input) {
    ...VerifyXmtpTargetViaXip42ResponseFragment
  }
}
    ${VerifyXmtpTargetViaXip42ResponseFragmentFragmentDoc}`;
var FetchDataDocument = lib_default`
    query fetchData {
  alert {
    ...AlertFragment
  }
  sourceGroup {
    ...SourceGroupFragment
  }
  connectedWallet {
    ...ConnectedWalletFragment
  }
  source {
    ...SourceFragment
  }
  targetGroup {
    ...TargetGroupFragment
  }
  emailTarget {
    ...EmailTargetFragment
  }
  smsTarget {
    ...SmsTargetFragment
  }
  telegramTarget {
    ...TelegramTargetFragment
  }
  discordTarget {
    ...DiscordTargetFragment
  }
  filter {
    ...FilterFragment
  }
}
    ${AlertFragmentFragmentDoc}
${SourceGroupFragmentFragmentDoc}
${ConnectedWalletFragmentFragmentDoc}
${SourceFragmentFragmentDoc}
${TargetGroupFragmentFragmentDoc}
${EmailTargetFragmentFragmentDoc}
${SmsTargetFragmentFragmentDoc}
${TelegramTargetFragmentFragmentDoc}
${DiscordTargetFragmentFragmentDoc}
${FilterFragmentFragmentDoc}`;
var FetchFusionDataDocument = lib_default`
    query fetchFusionData {
  alert {
    ...AlertFragment
  }
  connectedWallet {
    ...ConnectedWalletFragment
  }
  targetGroup {
    ...TargetGroupFragment
  }
}
    ${AlertFragmentFragmentDoc}
${ConnectedWalletFragmentFragmentDoc}
${TargetGroupFragmentFragmentDoc}`;
var FindTenantConfigDocument = lib_default`
    query findTenantConfig($input: FindTenantConfigInput!) {
  findTenantConfig(findTenantConfigInput: $input) {
    ...TenantConfigFragment
  }
}
    ${TenantConfigFragmentFragmentDoc}`;
var GetActiveAlertsDocument = lib_default`
    query getActiveAlerts($first: Int, $after: String, $fusionEventId: String!) {
  activeAlerts(
    after: $after
    first: $first
    activeAlertsInput: {fusionEventId: $fusionEventId}
  ) {
    nodes {
      ...ActiveAlertFragment
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${ActiveAlertFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
var GetAlertsDocument = lib_default`
    query getAlerts {
  alert {
    ...AlertFragment
  }
}
    ${AlertFragmentFragmentDoc}`;
var GetConfigurationForDappDocument = lib_default`
    query getConfigurationForDapp($dappAddress: String!) {
  configurationForDapp(getConfigurationForDappInput: {dappAddress: $dappAddress}) {
    supportedSmsCountryCodes
    supportedTargetTypes
  }
}
    `;
var GetConnectedWalletsDocument = lib_default`
    query getConnectedWallets {
  connectedWallet {
    ...ConnectedWalletFragment
  }
}
    ${ConnectedWalletFragmentFragmentDoc}`;
var GetDiscordTargetsDocument = lib_default`
    query getDiscordTargets {
  discordTarget {
    ...DiscordTargetFragment
  }
}
    ${DiscordTargetFragmentFragmentDoc}`;
var GetEmailTargetsDocument = lib_default`
    query getEmailTargets {
  emailTarget {
    ...EmailTargetFragment
  }
}
    ${EmailTargetFragmentFragmentDoc}`;
var GetFiltersDocument = lib_default`
    query getFilters {
  filter {
    ...FilterFragment
  }
}
    ${FilterFragmentFragmentDoc}`;
var GetFusionNotificationHistoryDocument = lib_default`
    query getFusionNotificationHistory($after: String, $first: Int, $includeHidden: Boolean, $includeRead: Boolean) {
  fusionNotificationHistory(
    after: $after
    first: $first
    includeHidden: $includeHidden
    includeRead: $includeRead
  ) {
    nodes {
      ...FusionNotificationHistoryEntryFragment
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${FusionNotificationHistoryEntryFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
var GetNotificationHistoryDocument = lib_default`
    query getNotificationHistory($after: String, $first: Int) {
  notificationHistory(after: $after, first: $first) {
    nodes {
      ...NotificationHistoryEntryFragment
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
}
    ${NotificationHistoryEntryFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
var GetSlackChannelTargetsDocument = lib_default`
    query getSlackChannelTargets($after: String, $first: Int, $ids: [String!]) {
  slackChannelTargets(input: {after: $after, first: $first, ids: $ids}) {
    ...GetSlackChannelTargetsResponseFragment
  }
}
    ${GetSlackChannelTargetsResponseFragmentFragmentDoc}`;
var GetSmsTargetsDocument = lib_default`
    query getSmsTargets {
  smsTarget {
    ...SmsTargetFragment
  }
}
    ${SmsTargetFragmentFragmentDoc}`;
var GetSourceConnectionDocument = lib_default`
    query getSourceConnection($input: GetSourcesInput, $first: Int, $after: String) {
  sources(getSourcesInput: $input, first: $first, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    nodes {
      ...SourceFragment
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${SourceFragmentFragmentDoc}`;
var GetSourceGroupsDocument = lib_default`
    query getSourceGroups {
  sourceGroup {
    ...SourceGroupFragment
  }
}
    ${SourceGroupFragmentFragmentDoc}`;
var GetSourcesDocument = lib_default`
    query getSources {
  source {
    ...SourceFragment
  }
}
    ${SourceFragmentFragmentDoc}`;
var GetTargetGroupsDocument = lib_default`
    query getTargetGroups {
  targetGroup {
    ...TargetGroupFragment
  }
}
    ${TargetGroupFragmentFragmentDoc}`;
var GetTelegramTargetsDocument = lib_default`
    query getTelegramTargets {
  telegramTarget {
    ...TelegramTargetFragment
  }
}
    ${TelegramTargetFragmentFragmentDoc}`;
var GetTenantConnectedWalletDocument = lib_default`
    query getTenantConnectedWallet($input: GetTenantConnectedWalletInput, $first: Int, $after: String) {
  tenantConnectedWallet(
    getTenantConnectedWalletInput: $input
    first: $first
    after: $after
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    nodes {
      ...TenantConnectedWalletFragment
      user {
        ...TenantUserFragment
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${TenantConnectedWalletFragmentFragmentDoc}
${TenantUserFragmentFragmentDoc}`;
var GetTenantUserDocument = lib_default`
    query getTenantUser($first: Int, $after: String) {
  tenantUser(first: $first, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    nodes {
      ...TenantUserFragment
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${TenantUserFragmentFragmentDoc}`;
var GetTopicsDocument = lib_default`
    query getTopics {
  topics {
    nodes {
      ...UserTopicFragment
    }
  }
}
    ${UserTopicFragmentFragmentDoc}`;
var GetUnreadNotificationHistoryCountDocument = lib_default`
    query getUnreadNotificationHistoryCount($cardId: String) {
  unreadNotificationHistoryCount(input: {cardId: $cardId}) {
    count
  }
}
    `;
var GetUserSettingsDocument = lib_default`
    query getUserSettings {
  userSettings {
    detailedAlertHistoryEnabled
    userHasChatEnabled
    ftuStage
  }
}
    `;
var GetWeb3TargetsDocument = lib_default`
    query getWeb3Targets {
  web3Targets {
    ...GetWeb3TargetResponseFragment
  }
}
    ${GetWeb3TargetResponseFragmentFragmentDoc}`;
var GetWebPushTargetsDocument = lib_default`
    query getWebPushTargets($ids: [String!], $first: Int, $after: String) {
  webPushTargets(
    input: {ids: $ids, first: $first, after: $after}
    first: $first
    after: $after
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    nodes {
      ...WebPushTargetFragment
    }
    edges {
      cursor
      node {
        ...WebPushTargetFragment
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${WebPushTargetFragmentFragmentDoc}`;
var GetWebhookTargetsDocument = lib_default`
    query getWebhookTargets {
  webhookTarget {
    ...WebhookTargetFragment
  }
}
    ${WebhookTargetFragmentFragmentDoc}`;
var defaultWrapper = (action, _operationName, _operationType, _variables) => action();
function getSdk(client, withWrapper = defaultWrapper) {
  return {
    addSourceToSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(AddSourceToSourceGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "addSourceToSourceGroup", "mutation", variables);
    },
    beginLogInByTransaction(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(BeginLogInByTransactionDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "beginLogInByTransaction", "mutation", variables);
    },
    beginLogInWithWeb3(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(BeginLogInWithWeb3Document, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "beginLogInWithWeb3", "mutation", variables);
    },
    broadcastMessage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(BroadcastMessageDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "broadcastMessage", "mutation", variables);
    },
    completeLogInByTransaction(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CompleteLogInByTransactionDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "completeLogInByTransaction", "mutation", variables);
    },
    completeLogInWithWeb3(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CompleteLogInWithWeb3Document, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "completeLogInWithWeb3", "mutation", variables);
    },
    connectWallet(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(ConnectWalletDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "connectWallet", "mutation", variables);
    },
    createAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateAlertDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createAlert", "mutation", variables);
    },
    createDirectPushAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateDirectPushAlertDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createDirectPushAlert", "mutation", variables);
    },
    createDiscordTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateDiscordTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createDiscordTarget", "mutation", variables);
    },
    createEmailTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateEmailTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createEmailTarget", "mutation", variables);
    },
    createFusionAlerts(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateFusionAlertsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createFusionAlerts", "mutation", variables);
    },
    createSlackChannelTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSlackChannelTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createSlackChannelTarget", "mutation", variables);
    },
    createSmsTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSmsTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createSmsTarget", "mutation", variables);
    },
    createSource(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSourceDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createSource", "mutation", variables);
    },
    createSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateSourceGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createSourceGroup", "mutation", variables);
    },
    createTargetGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateTargetGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createTargetGroup", "mutation", variables);
    },
    createTelegramTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateTelegramTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createTelegramTarget", "mutation", variables);
    },
    createTenantUser(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateTenantUserDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createTenantUser", "mutation", variables);
    },
    createWeb3Target(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateWeb3TargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createWeb3Target", "mutation", variables);
    },
    createWebPushTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateWebPushTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createWebPushTarget", "mutation", variables);
    },
    createWebhookTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CreateWebhookTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "createWebhookTarget", "mutation", variables);
    },
    deleteAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteAlertDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteAlert", "mutation", variables);
    },
    deleteDirectPushAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteDirectPushAlertDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteDirectPushAlert", "mutation", variables);
    },
    deleteSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteSourceGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteSourceGroup", "mutation", variables);
    },
    deleteTargetGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteTargetGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteTargetGroup", "mutation", variables);
    },
    deleteUserAlert(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteUserAlertDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteUserAlert", "mutation", variables);
    },
    deleteWebPushTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteWebPushTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteWebPushTarget", "mutation", variables);
    },
    deleteWebhookTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DeleteWebhookTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "deleteWebhookTarget", "mutation", variables);
    },
    logInByOidc(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(LogInByOidcDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "logInByOidc", "mutation", variables);
    },
    logInFromDapp(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(LogInFromDappDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "logInFromDapp", "mutation", variables);
    },
    logInFromService(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(LogInFromServiceDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "logInFromService", "mutation", variables);
    },
    markFusionNotificationHistoryAsRead(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(MarkFusionNotificationHistoryAsReadDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "markFusionNotificationHistoryAsRead", "mutation", variables);
    },
    publishFusionMessage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(PublishFusionMessageDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "publishFusionMessage", "mutation", variables);
    },
    refreshAuthorization(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(RefreshAuthorizationDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "refreshAuthorization", "mutation", variables);
    },
    removeSourceFromSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(RemoveSourceFromSourceGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "removeSourceFromSourceGroup", "mutation", variables);
    },
    sendEmailTargetVerificationRequest(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(SendEmailTargetVerificationRequestDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "sendEmailTargetVerificationRequest", "mutation", variables);
    },
    sendMessage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(SendMessageDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "sendMessage", "mutation", variables);
    },
    updateSourceGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(UpdateSourceGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "updateSourceGroup", "mutation", variables);
    },
    updateTargetGroup(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(UpdateTargetGroupDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "updateTargetGroup", "mutation", variables);
    },
    updateUserSettings(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(UpdateUserSettingsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "updateUserSettings", "mutation", variables);
    },
    updateWebPushTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(UpdateWebPushTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "updateWebPushTarget", "mutation", variables);
    },
    verifyCbwTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(VerifyCbwTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "verifyCbwTarget", "mutation", variables);
    },
    verifyXmtpTarget(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(VerifyXmtpTargetDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "verifyXmtpTarget", "mutation", variables);
    },
    verifyXmtpTargetViaXip42(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(VerifyXmtpTargetViaXip42Document, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "verifyXmtpTargetViaXip42", "mutation", variables);
    },
    fetchData(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(FetchDataDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "fetchData", "query", variables);
    },
    fetchFusionData(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(FetchFusionDataDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "fetchFusionData", "query", variables);
    },
    findTenantConfig(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(FindTenantConfigDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "findTenantConfig", "query", variables);
    },
    getActiveAlerts(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetActiveAlertsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getActiveAlerts", "query", variables);
    },
    getAlerts(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetAlertsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getAlerts", "query", variables);
    },
    getConfigurationForDapp(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetConfigurationForDappDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getConfigurationForDapp", "query", variables);
    },
    getConnectedWallets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetConnectedWalletsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getConnectedWallets", "query", variables);
    },
    getDiscordTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetDiscordTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getDiscordTargets", "query", variables);
    },
    getEmailTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetEmailTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getEmailTargets", "query", variables);
    },
    getFilters(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetFiltersDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getFilters", "query", variables);
    },
    getFusionNotificationHistory(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetFusionNotificationHistoryDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getFusionNotificationHistory", "query", variables);
    },
    getNotificationHistory(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetNotificationHistoryDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getNotificationHistory", "query", variables);
    },
    getSlackChannelTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSlackChannelTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getSlackChannelTargets", "query", variables);
    },
    getSmsTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSmsTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getSmsTargets", "query", variables);
    },
    getSourceConnection(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSourceConnectionDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getSourceConnection", "query", variables);
    },
    getSourceGroups(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSourceGroupsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getSourceGroups", "query", variables);
    },
    getSources(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetSourcesDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getSources", "query", variables);
    },
    getTargetGroups(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTargetGroupsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getTargetGroups", "query", variables);
    },
    getTelegramTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTelegramTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getTelegramTargets", "query", variables);
    },
    getTenantConnectedWallet(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTenantConnectedWalletDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getTenantConnectedWallet", "query", variables);
    },
    getTenantUser(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTenantUserDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getTenantUser", "query", variables);
    },
    getTopics(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetTopicsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getTopics", "query", variables);
    },
    getUnreadNotificationHistoryCount(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetUnreadNotificationHistoryCountDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getUnreadNotificationHistoryCount", "query", variables);
    },
    getUserSettings(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetUserSettingsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getUserSettings", "query", variables);
    },
    getWeb3Targets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetWeb3TargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getWeb3Targets", "query", variables);
    },
    getWebPushTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetWebPushTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getWebPushTargets", "query", variables);
    },
    getWebhookTargets(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(GetWebhookTargetsDocument, variables, __spreadValues(__spreadValues({}, requestHeaders), wrappedRequestHeaders)), "getWebhookTargets", "query", variables);
    }
  };
}

// lib/NotifiService.ts
var NotifiService = class {
  constructor(graphQLClient, _notifiSubService) {
    this._notifiSubService = _notifiSubService;
    this._typedClient = getSdk(graphQLClient);
  }
  setJwt(jwt) {
    this._jwt = jwt;
    this._notifiSubService.setJwt(jwt);
  }
  async logOut() {
    this._jwt = void 0;
    this._notifiSubService.setJwt(void 0);
  }
  async addSourceToSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.addSourceToSourceGroup(variables, headers);
  }
  async beginLogInByTransaction(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.beginLogInByTransaction(variables, headers);
  }
  async broadcastMessage(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.broadcastMessage(variables, headers);
  }
  async completeLogInByTransaction(variables) {
    var _a, _b;
    const headers = this._requestHeaders();
    const result = await this._typedClient.completeLogInByTransaction(
      variables,
      headers
    );
    const token = (_b = (_a = result.completeLogInByTransaction) == null ? void 0 : _a.authorization) == null ? void 0 : _b.token;
    if (token !== void 0) {
      this._onAuthComplete(token);
    }
    return result;
  }
  async connectWallet(variables) {
    const headers = this._requestHeaders();
    return await this._typedClient.connectWallet(variables, headers);
  }
  async createAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createAlert(variables, headers);
  }
  async createFusionAlerts(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createFusionAlerts(variables, headers);
  }
  async createDirectPushAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createDirectPushAlert(variables, headers);
  }
  async createEmailTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createEmailTarget(variables, headers);
  }
  async createDiscordTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createDiscordTarget(variables, headers);
  }
  async createSlackChannelTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSlackChannelTarget(variables, headers);
  }
  async createWeb3Target(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createWeb3Target(variables, headers);
  }
  async createSmsTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSmsTarget(variables, headers);
  }
  async createSource(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSource(variables, headers);
  }
  async createSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createSourceGroup(variables, headers);
  }
  async createTargetGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createTargetGroup(variables, headers);
  }
  async createTenantUser(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createTenantUser(variables, headers);
  }
  async createWebhookTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createWebhookTarget(variables, headers);
  }
  async createTelegramTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createTelegramTarget(variables, headers);
  }
  async deleteAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteAlert(variables, headers);
  }
  async DeleteDirectPushAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteDirectPushAlert(variables, headers);
  }
  async deleteUserAlert(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteUserAlert(variables, headers);
  }
  async deleteSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteSourceGroup(variables, headers);
  }
  async deleteTargetGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteTargetGroup(variables, headers);
  }
  async deleteWebhookTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteWebhookTarget(variables, headers);
  }
  /** @deprecated use fetchFusionData instead. This is for legacy  */
  async fetchData(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.fetchData(variables, headers);
  }
  async fetchFusionData(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.fetchFusionData(variables, headers);
  }
  async findTenantConfig(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.findTenantConfig(variables, headers);
  }
  async getAlerts(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getAlerts(variables, headers);
  }
  async getActiveAlerts(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getActiveAlerts(variables, headers);
  }
  async getConfigurationForDapp(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getConfigurationForDapp(variables, headers);
  }
  async getConnectedWallets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getConnectedWallets(variables, headers);
  }
  async getEmailTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getEmailTargets(variables, headers);
  }
  async getDiscordTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getDiscordTargets(variables, headers);
  }
  async getSlackChannelTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSlackChannelTargets(variables, headers);
  }
  async getWeb3Targets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getWeb3Targets(variables, headers);
  }
  async getFilters(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getFilters(variables, headers);
  }
  async getFusionNotificationHistory(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getFusionNotificationHistory(variables, headers);
  }
  /**
   * @deprecated Use getFusionNotificationHistory instead
   */
  async getNotificationHistory(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getNotificationHistory(variables, headers);
  }
  async getSmsTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSmsTargets(variables, headers);
  }
  async getSourceConnection(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSourceConnection(variables, headers);
  }
  async getSourceGroups(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSourceGroups(variables, headers);
  }
  async getSources(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getSources(variables, headers);
  }
  async getTargetGroups(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTargetGroups(variables, headers);
  }
  async getTelegramTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTelegramTargets(variables, headers);
  }
  async getTenantConnectedWallets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTenantConnectedWallet(variables, headers);
  }
  async getTenantUser(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTenantUser(variables, headers);
  }
  async getTopics(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getTopics(variables, headers);
  }
  async getUnreadNotificationHistoryCount(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getUnreadNotificationHistoryCount(
      variables,
      headers
    );
  }
  /**
   * @deprecated Use addEventListener instead
   */
  subscribeNotificationHistoryStateChanged(onMessageReceived, onError, onComplete) {
    return this._notifiSubService.subscribe(
      this._jwt,
      stateChangedSubscriptionQuery,
      onMessageReceived,
      onError,
      onComplete
    );
  }
  async wsDispose() {
    this._notifiSubService.disposeClient();
  }
  /**
   * @returns {string} - The id of the event listener (used to remove the event listener)
   */
  addEventListener(event, callBack, onError, onComplete) {
    return this._notifiSubService.addEventListener(
      event,
      callBack,
      onError,
      onComplete
    );
  }
  removeEventListener(event, id) {
    return this._notifiSubService.removeEventListener(event, id);
  }
  async getUserSettings(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getUserSettings(variables, headers);
  }
  async getWebhookTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getWebhookTargets(variables, headers);
  }
  async logInFromDapp(variables) {
    var _a, _b;
    const headers = this._requestHeaders();
    const result = await this._typedClient.logInFromDapp(variables, headers);
    const token = (_b = (_a = result.logInFromDapp) == null ? void 0 : _a.authorization) == null ? void 0 : _b.token;
    if (token !== void 0) {
      this._onAuthComplete(token);
    }
    return result;
  }
  async logInFromService(variables) {
    var _a;
    const headers = this._requestHeaders();
    const result = await this._typedClient.logInFromService(variables, headers);
    const token = (_a = result.logInFromService) == null ? void 0 : _a.token;
    if (token !== void 0) {
      this._onAuthComplete(token);
    }
    return result;
  }
  async logInByOidc(variables) {
    var _a, _b, _c;
    const headers = this._requestHeaders();
    const result = await this._typedClient.logInByOidc(variables, headers);
    const token = (_c = (_b = (_a = result.logInByOidc) == null ? void 0 : _a.user) == null ? void 0 : _b.authorization) == null ? void 0 : _c.token;
    if (token !== void 0) {
      this._onAuthComplete(token);
    }
    return result;
  }
  async markFusionNotificationHistoryAsRead(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.markFusionNotificationHistoryAsRead(
      variables,
      headers
    );
  }
  async updateUserSettings(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.updateUserSettings(variables, headers);
  }
  async refreshAuthorization(variables) {
    var _a;
    const headers = this._requestHeaders();
    const result = await this._typedClient.refreshAuthorization(
      variables,
      headers
    );
    const token = (_a = result.refreshAuthorization) == null ? void 0 : _a.token;
    if (token !== void 0) {
      this._onAuthComplete(token);
    }
    return result;
  }
  async removeSourceFromSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.removeSourceFromSourceGroup(variables, headers);
  }
  async sendEmailTargetVerificationRequest(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.sendEmailTargetVerificationRequest(
      variables,
      headers
    );
  }
  async sendMessage(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.sendMessage(variables, headers);
  }
  async updateSourceGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.updateSourceGroup(variables, headers);
  }
  async updateTargetGroup(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.updateTargetGroup(variables, headers);
  }
  async beginLogInWithWeb3(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.beginLogInWithWeb3(variables, headers);
  }
  async completeLogInWithWeb3(variables) {
    var _a, _b, _c;
    const headers = this._requestHeaders();
    const result = await this._typedClient.completeLogInWithWeb3(
      variables,
      headers
    );
    const token = (_c = (_b = (_a = result == null ? void 0 : result.completeLogInWithWeb3) == null ? void 0 : _a.user) == null ? void 0 : _b.authorization) == null ? void 0 : _c.token;
    if (token !== void 0) {
      this._onAuthComplete(token);
    }
    return result;
  }
  async verifyCbwTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.verifyCbwTarget(variables, headers);
  }
  async verifyXmtpTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.verifyXmtpTarget(variables, headers);
  }
  async verifyXmtpTargetViaXip42(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.verifyXmtpTargetViaXip42(variables, headers);
  }
  async createWebPushTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.createWebPushTarget(variables, headers);
  }
  async updateWebPushTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.updateWebPushTarget(variables, headers);
  }
  async deleteWebPushTarget(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.deleteWebPushTarget(variables, headers);
  }
  async getWebPushTargets(variables) {
    const headers = this._requestHeaders();
    return this._typedClient.getWebPushTargets(variables, headers);
  }
  _onAuthComplete(jwt) {
    this._jwt = jwt;
    this._notifiSubService.setJwt(jwt);
  }
  _requestHeaders() {
    const requestId = uuid();
    const headers = {
      "X-Request-Id": requestId,
      "X-Notifi-Client-Version": version
    };
    if (this._jwt !== void 0) {
      headers["Authorization"] = `Bearer ${this._jwt}`;
    }
    return headers;
  }
};

// lib/NotifiSubscriptionService.ts
import {
  createClient
} from "graphql-ws";
import { Observable } from "relay-runtime";

// lib/NotifiEventEmitter.ts
var NotifiEventEmitter = class {
  constructor() {
    this.listeners = {};
  }
  on(event, listener, id) {
    if (!this.listeners[event]) {
      this.listeners[event] = {};
    }
    this.listeners[event][id] = // ⬅ Workaround for TS limitation (not able to infer that this.listeners[event] is defined)
    listener;
  }
  off(event, id) {
    var _a;
    if (!((_a = this.listeners[event]) == null ? void 0 : _a[id])) return;
    this.listeners[event][
      // ⬅ Workaround for TS limitation (not able to infer that this.listeners[event] is defined)
      id
    ].subscription.unsubscribe();
    delete this.listeners[event][id];
  }
  emit(event, id, ...args) {
    var _a, _b;
    if (!((_a = this.listeners[event]) == null ? void 0 : _a[id])) return;
    if ((_b = this.listeners[event]) == null ? void 0 : _b[id]) {
      this.listeners[event][id].callback(...args);
    }
  }
};

// lib/NotifiSubscriptionService.ts
var NotifiSubscriptionService = class {
  constructor(wsurl, webSocketImpl) {
    this.wsurl = wsurl;
    this.webSocketImpl = webSocketImpl;
    this.eventEmitter = new NotifiEventEmitter();
    this.setJwt = (jwt) => {
      this._jwt = jwt;
    };
    /**
     * @returns {string} - The id of the event listener (used to remove the event listener)
     */
    this.addEventListener = (event, callback, onError, onComplete) => {
      const id = Math.random().toString(36).slice(2, 11);
      const subscribeInputs = {
        subscriptionQuery: "",
        // ⬅ Placeholder (empty string intentionally)
        id,
        onError,
        onComplete
      };
      switch (event) {
        case "stateChanged":
          subscribeInputs.subscriptionQuery = stateChangedSubscriptionQuery;
          break;
        case "tenantActiveAlertChanged":
          subscribeInputs.subscriptionQuery = tenantActiveAlertChangedSubscriptionQuery;
          break;
        default:
          throw new Error("Unknown event");
      }
      const subscription = this._subscribe(subscribeInputs);
      if (!subscription)
        throw new Error(
          "NotifiSubscriptionService.addEventListener: Subscription failed"
        );
      this.eventEmitter.on(event, { callback, subscription }, id);
      return id;
    };
    this.removeEventListener = (event, id) => {
      return this.eventEmitter.off(event, id);
    };
    /**
     * @returns null if jwt or wsClient is not correctly set
     */
    this._subscribe = ({
      subscriptionQuery,
      id,
      onError,
      onComplete
    }) => {
      if (!this._wsClient) {
        this._initializeClient();
      }
      if (!this._wsClient || !this._jwt) return null;
      const observable = this._toObservable(this._wsClient, {
        query: subscriptionQuery,
        extensions: {
          type: "start"
        }
      });
      const subscription = observable.subscribe({
        next: (data) => {
          switch (subscriptionQuery) {
            case stateChangedSubscriptionQuery:
              const stateChangedData = getSubscriptionData("stateChanged", data);
              if (!stateChangedData) {
                throw new Error("Invalid stateChanged event data");
              }
              this.eventEmitter.emit("stateChanged", id, stateChangedData);
              break;
            case tenantActiveAlertChangedSubscriptionQuery:
              const tenantActiveAlertChangedData = getSubscriptionData(
                "tenantActiveAlertChanged",
                data
              );
              if (!tenantActiveAlertChangedData) {
                throw new Error("Invalid tenantActiveAlertChanged event data");
              }
              this.eventEmitter.emit(
                "tenantActiveAlertChanged",
                id,
                tenantActiveAlertChangedData
              );
              break;
            default:
              console.warn("Unknown subscription query:", subscriptionQuery);
          }
        },
        error: onError,
        complete: onComplete
      });
      return subscription;
    };
    this._initializeClient = () => {
      if (!this._jwt)
        throw new Error(
          "NotifiSubscriptionService._initializeClient: Missing JWT"
        );
      this._wsClient = createClient({
        url: this.wsurl,
        connectionParams: {
          Authorization: `Bearer ${this._jwt}`
        },
        /* https://github.com/enisdenjo/graphql-ws/blob/c030ed1d5f7e8a552dffbfd46712caf7dfe91a54/src/client.ts#L400 */
        webSocketImpl: this.webSocketImpl
      });
    };
    /* ⬇⬇⬇⬇⬇ Deprecated methods ⬇⬇⬇⬇⬇⬇ */
    /**
     * @deprecated Should not directly manipulate the websocket client. Instead use the returned subscription object to manage the subscription. ex. subscription.unsubscribe()
     */
    this.disposeClient = () => {
      if (this._wsClient) {
        this._jwt = void 0;
        this._wsClient.terminate();
        this._wsClient.dispose();
      }
    };
    /**
     * @deprecated Use addEventListener instead
     */
    this.subscribe = (jwt, subscriptionQuery, onMessageReceived, onError, onComplete) => {
      this._jwt = jwt;
      if (!this._wsClient) {
        this._initializeClient();
      }
      if (!this._wsClient) return null;
      const observable = this._toObservable(this._wsClient, {
        query: subscriptionQuery,
        extensions: {
          type: "start"
        }
      });
      const subscription = observable.subscribe({
        next: (data) => {
          if (onMessageReceived) {
            onMessageReceived(data);
          }
        },
        error: (error) => {
          if (onError && error instanceof Error) {
            onError(error);
          }
        },
        complete: () => {
          if (onComplete) {
            onComplete();
          }
        }
      });
      return subscription;
    };
  }
  _toObservable(client, operation) {
    return Observable.create(
      (observer) => client.subscribe(operation, {
        next: (data) => observer.next(data),
        error: (err) => {
          if (err instanceof Error) {
            observer.error(err);
          }
        },
        complete: () => observer.complete()
      })
    );
  }
};
var getSubscriptionData = (subscriptionEvent, subscriptionEventData) => {
  if (typeof subscriptionEventData !== "object" || subscriptionEventData === null)
    return null;
  if (!("data" in subscriptionEventData)) return null;
  const { data: eventPayload } = subscriptionEventData;
  if (typeof eventPayload === "object" && eventPayload !== null && subscriptionEvent in eventPayload) {
    return eventPayload[subscriptionEvent];
  }
  return null;
};
export {
  NotifiEventEmitter,
  NotifiService,
  NotifiSubscriptionService
};
